<accelerator-location-chips
  [placeholder]="placeholder"
  [locations]="locations"
  [disabled]="disabled"
  (removed)="remove($event)"
  (selected)="select($event)"
  [hilite]="hilite"
></accelerator-location-chips>
